import { useEffect, useState } from "react";
import { Select } from "antd";
import axiosInstance from "../../variables/api/axiosInstance";
import { getActiveInventaireCodeId } from "../../variables/activeInventaire";
import { rightsService } from "../../services/rightsService";

/**
 * Sélecteur d'inventaire pour rattacher une réévaluation. Ne liste que les inventaires RATTACHABLES
 * (OUVERTS et de l'organisme de l'utilisateur — endpoint /api/inventaire/rattachables). Pré-rempli
 * avec l'inventaire actif s'il est rattachable et qu'aucune valeur n'est déjà fournie.
 *
 * Props : value (codeId | null), onChange(codeId | null), style.
 */
export default function InventaireSelectField({ value, onChange, style }) {
    const [items, setItems] = useState([]);
    const canRead = rightsService("HSI116"); // lecture inventaires (voir / alimenter)

    useEffect(() => {
        if (!canRead) return;
        axiosInstance.get("/api/inventaire/rattachables")
            .then((res) => {
                const list = Array.isArray(res.data) ? res.data : [];
                setItems(list);
                if (!value) {
                    const actif = getActiveInventaireCodeId();
                    if (actif && list.some((i) => i.codeId === actif)) {
                        onChange && onChange(actif);            // 1) priorité à l'inventaire ACTIF choisi
                    } else if (list.length === 1) {
                        onChange && onChange(list[0].codeId);   // 2) un SEUL inventaire ouvert → pré-remplir d'office
                    }
                    // 3) plusieurs ouverts et aucun actif → on NE devine PAS (l'utilisateur choisit ci-dessous)
                }
            })
            .catch(() => setItems([]));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Pas le droit de lecture inventaires → on n'affiche pas le sélecteur de rattachement.
    if (!canRead) return null;

    // Indice visible : un inventaire est ouvert mais aucun n'est sélectionné → la réévaluation ne
    // serait PAS rattachée. Alerte surtout utile quand plusieurs sont ouverts (pas de pré-remplissage).
    const alerteNonRattache = items.length > 0 && !value;

    return (
        <>
            <Select
                allowClear showSearch optionFilterProp="label"
                status={alerteNonRattache ? "warning" : undefined}
                style={style || { width: "100%" }}
                placeholder="Aucun (réévaluation hors inventaire)"
                value={value || undefined}
                onChange={(v) => onChange && onChange(v || null)}
                options={items.map((i) => ({ value: i.codeId, label: i.titre }))}
                notFoundContent="Aucun inventaire ouvert"
            />
            {alerteNonRattache && (
                <div style={{ fontSize: 12, color: "#ad6800", marginTop: 4 }}>
                    {items.length > 1
                        ? "Plusieurs inventaires ouverts : sélectionnez-en un pour rattacher cette réévaluation."
                        : "Un inventaire est ouvert : sélectionnez-le pour rattacher cette réévaluation."}
                </div>
            )}
        </>
    );
}
